import { styled } from '@mui/material/styles';
import Markdown from 'markdown-to-jsx';

import { RichMarkdownDS } from '../../sharedStyles/textStyles';

const bfStyles = ({ theme, $BFstyles }) =>
  $BFstyles &&
  `
     em {
      text-style: normal;
      font-weight: 700;
      color: ${theme.DS_palette.tag.text} !important;
      padding-right: 4px;
    }
  `;

export const StyledMarkdown = styled(Markdown)(
  ({ theme, $BFstyles }) => `
  ${RichMarkdownDS({ theme })};
  ${bfStyles({ theme, $BFstyles })};

  ol{
    padding-left: ${theme.DS_spacing(['sm'])};
    margin-left: ${theme.DS_spacing(['sm'])};
  }   
  ul {
   padding-left: ${theme.DS_spacing(['sm'])};
    list-style: inside;
    li:marker{
      font-size: small;

    }

 
`,
);
